import $ from 'jquery'

let target = target || {};
target = {
	form: $('[data-target-form]'),//
	header: $('[data-target-header]'),
};

let trigger = trigger || {};
trigger = {
	reset: $('[data-trigger-reset]'),
	submit: $('[data-trigger-submit]')
};

export function formValid() {
	if(!target.form.length) return;

	$.validator.setDefaults({
		debug: false,
		success: null,
		errorClass: "c-form__error",
		errorElement: "div",
	});

	$.validator.addMethod("numberHyphen", function(value, element) {
		return this.optional(element) || /^[\d,-]+$/.test(value);　//数字のみ
	});
	$.validator.addMethod("kanaHyphen", function(value, element) {
		return this.optional(element) || /^[ァ-ヶｦ-ﾟー゛]+$/u.test(value);　//カタカナのみ
	});

	//標準エラーメッセージの変更
	$.extend($.validator.messages, {
		email: '正しいメールアドレスの形式で入力して下さい'
	});
	
	target.form.validate({ 
		rules: {
			"お名前": {
				required: true　　　//入力が間違った時
			},
			"連絡先電話番号": {
				required: true,
				numberHyphen: true
			},
			"お名前(カナ)": {
				required: true,
				kanaHyphen: true
			},
			"郵便番号": {
				required: true
			},
			"都道府県": {
				required: true
			},
			"市区町村/番地": {
				required: true
			},
			"メールアドレス": {
				required: true
			}
		},
		messages: {
            "お名前": {
                required: "名前を入力してください",　//エラーメッセージを表示
			},
			"連絡先電話番号": {
				required: "連絡先電話番号を入力してください",
				numberHyphen: "連絡先電話番号を数字で入力してください"
			},
			"お名前(カナ)": {
				required: "お名前(カナ)を入力してください",
				kanaHyphen: "カタカナで入力してください"
			}, 
			"郵便番号": {
                required: "郵便番号を入力してください",
			}, 
			"都道府県": {
                required: "都道府県を入力してください",
			}, 
			"市区町村/番地": {
                required: "市区町村/番地を入力してください",
			}, 
			"メールアドレス": {
				required: "メールアドレスを入力してください"
				
			}
		}
	});
}

export function errorJump() {
	trigger.submit.on('click', () => {
		const headerHeight = target.header.height();
		if(target.form.valid()) {
			trigger.submit.submit();
		} else {
			let errorPosition = target.form.find('input.c-form__error').closest('.c-form__item').offset().top;
			$('#form').animate({scrollTop: errorPosition - headerHeight}, 'fast', 'swing');
		}
	});
}

export function formReset() {
	trigger.reset.on('click', (event) => {
		event.preventDefault();
		const validator = target.form.validate();
		validator.resetForm();
		$('input').val('');
		$('select').prop('selectedIndex', 0);
		$('textarea').val('');
	});
}

export function submitCheck() {
	if(!target.form.length) return;

	validateForm(target.form);
	target.form.on('keyup change input', '[required]', () => {
		validateForm(target.form);
	});

	function validateForm(form) {
		let valid = form.validate().checkForm();
		if(valid) {
			trigger.submit.removeClass('is-disabled');
		} else {
			trigger.submit.addClass('is-disabled');
		}
	}
}

export function enterDisallow() {
	$(document).on("keypress", "input", (event) => {
		return event.which !== 13;
	});
}


// WEBPACK FOOTER //
// ./src/js/util/formValid.js